import { Component, Input } from '@angular/core';
import { CurrentTenantService } from '@suvo-bi-users';
import { IPresentationTileInstance } from '../../../../interfaces/tiles/definitions/presentation-tile-definition.interface';
import { resolveSiteAssetCssValue } from '../../../../utils/resolve-site-asset-url.util';

@Component({
  standalone: false,
  selector: 'suvo-bi-presentation-tile',
  templateUrl: './presentation-tile.component.html',
  styleUrls: ['./presentation-tile.component.scss'],
})
export class PresentationTileComponent {
  @Input() tileInstance: IPresentationTileInstance;

  constructor(private readonly tenantService: CurrentTenantService) {}

  get backgroundStyle(): string {
    return resolveSiteAssetCssValue(
      this.tileInstance?.background ?? '',
      this.tenantService.currentTenantData?.primaryWebUrl ?? '',
    );
  }
}
